import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import {
  TAssignedFilters,
  TOpenFilters,
  TCompleteFilters,
  TClosedFilters,
  TCanceledFilters
} from "interfaces/MaintenanceWorkOrdersPageState";

export const SET_OPEN_FILTERS = "WORK_ORDERS_PAGE_SET_OPEN_FILTERS";
export const CLEAR_OPEN_FILTERS = "WORK_ORDERS_PAGE_CLEAR_OPEN_FILTERS";
export const SET_ASSIGNED_FILTERS = "WORK_ORDERS_PAGE_SET_ASSIGNED_FILTERS";
export const CLEAR_ASSIGNED_FILTERS = "WORK_ORDERS_PAGE_CLEAR_ASSIGNED_FILTERS";
export const SET_COMPLETE_FILTERS = "WORK_ORDERS_PAGE_SET_COMPLETE_FILTERS";
export const CLEAR_COMPLETE_FILTERS = "WORK_ORDERS_PAGE_CLEAR_COMPLETE_FILTERS";
export const SET_CLOSED_FILTERS = "WORK_ORDERS_PAGE_SET_CLOSED_FILTERS";
export const CLEAR_CLOSED_FILTERS = "WORK_ORDERS_PAGE_CLEAR_CLOSED_FILTERS";
export const SET_CANCELED_FILTERS = "WORK_ORDERS_PAGE_SET_CANCELED_FILTERS";
export const CLEAR_CANCELED_FILTERS = "WORK_ORDERS_PAGE_CLEAR_CANCELED_FILTERS";

type TActionTypes =
  | typeof SET_OPEN_FILTERS
  | typeof CLEAR_OPEN_FILTERS
  | typeof SET_ASSIGNED_FILTERS
  | typeof CLEAR_ASSIGNED_FILTERS
  | typeof SET_COMPLETE_FILTERS
  | typeof CLEAR_COMPLETE_FILTERS
  | typeof SET_CLOSED_FILTERS
  | typeof CLEAR_CLOSED_FILTERS
  | typeof SET_CANCELED_FILTERS
  | typeof CLEAR_CANCELED_FILTERS;

type TClearFiltersTypes =
  | typeof CLEAR_OPEN_FILTERS
  | typeof CLEAR_ASSIGNED_FILTERS
  | typeof CLEAR_COMPLETE_FILTERS
  | typeof CLEAR_CLOSED_FILTERS
  | typeof CLEAR_CANCELED_FILTERS;

export interface IMaintenanceWorkOrdersPagesAC {
  type: TActionTypes;
  selectedFacility: racehorse360.IFacility;
  openFilters: TOpenFilters;
  assignedFilters: TAssignedFilters;
  completeFilters: TCompleteFilters;
  closedFilters: TClosedFilters;
  canceledFilters: TCanceledFilters;
}

const clearFiltersByType = (
  type: TClearFiltersTypes
): Pick<IMaintenanceWorkOrdersPagesAC, "type"> => {
  return { type };
};

export const setOpenFilters = (
  openFilters: TOpenFilters
): Pick<IMaintenanceWorkOrdersPagesAC, "type" | "openFilters"> => {
  return {
    type: SET_OPEN_FILTERS,
    openFilters
  };
};

export const clearOpenFilters = clearFiltersByType(CLEAR_OPEN_FILTERS);

export const setAssignedFilters = (
  assignedFilters: TAssignedFilters
): Pick<IMaintenanceWorkOrdersPagesAC, "type" | "assignedFilters"> => {
  return {
    type: SET_ASSIGNED_FILTERS,
    assignedFilters
  };
};

export const clearAssignedFilters = clearFiltersByType(CLEAR_ASSIGNED_FILTERS);

export const setCompleteFilters = (
  completeFilters: TCompleteFilters
): Pick<IMaintenanceWorkOrdersPagesAC, "type" | "completeFilters"> => {
  return {
    type: SET_COMPLETE_FILTERS,
    completeFilters
  };
};

export const clearCompleteFilters = clearFiltersByType(CLEAR_COMPLETE_FILTERS);

export const setClosedFilters = (
  closedFilters: TClosedFilters
): Pick<IMaintenanceWorkOrdersPagesAC, "type" | "closedFilters"> => {
  return {
    type: SET_CLOSED_FILTERS,
    closedFilters
  };
};

export const clearClosedFilters = clearFiltersByType(CLEAR_CLOSED_FILTERS);

export const setCanceledFilters = (
  canceledFilters: TCanceledFilters
): Pick<IMaintenanceWorkOrdersPagesAC, "type" | "canceledFilters"> => {
  return {
    type: SET_CANCELED_FILTERS,
    canceledFilters
  };
};

export const clearCanceledFilters = clearFiltersByType(CLEAR_CANCELED_FILTERS);
